import { Component, OnInit, Input, Output, EventEmitter, Inject, OnChanges, SimpleChanges} from '@angular/core';
import { Observable, Subscription, EMPTY, empty, of } from "rxjs";
import { tap } from "rxjs/operators";

import * as moment from 'moment';
import 'moment-timezone';
import 'moment/locale/sl';
moment.tz.setDefault("Europe/Ljubljana");

import { ShopDetailService } from '../../../core/services/shop-detail.service';
import { Employee } from '../../../core/models/employee.model';
import { Pick } from '../../../core/models/cart/pick.model';
import { Real } from '../../../core/models/real.model';

import { Slot } from '../../../core/models/cart/slot.model';

import * as equal from 'fast-deep-equal';
import { LOCALE_ID } from '@angular/core';
import { ProviderServiceService } from '../../../core/services/provider-service.service'
import { ModalController } from '@ionic/angular';
import { OfferInfoModalComponent } from '../../../shared/offer-info-modal/offer-info-modal.component';
import { PaymentInfoModalComponent } from '../../../shared/payment-info-modal/payment-info-modal.component';
import { TranslateService } from "@ngx-translate/core";
import { PpTranslatePipe } from '../../../shared/pipes/pp-translate.pipe';

@Component({
  selector: 'app-slots',
  templateUrl: './slots.component.html',
  styleUrls: ['./slots.component.scss'],
})
export class SlotsComponent implements OnInit, OnChanges {

  @Input() slots$: Observable<any>;

  @Input() slots: any;

  @Input() slotCombinations$: Observable<any>;
  @Input() selectedTime: string;
  @Input() pick: Pick;
  @Input() eventFilter: string;
  @Input() real: Real;
  @Input() initialSlot$: Observable< Slot | null >;

  @Output() onSlotPicked = new EventEmitter<object>();

  employees: Employee[];

  employeesMap: Object;

  employeesSubscription: Subscription;

  initialSlotSubscription: Subscription;

  slotsSubscription: Subscription;

  servicesSnapshot: {};

  combinationPicked: number = 0;

  eventPreference: string;

  orTranslations = {
    'sl': 'ali',
    'en': 'or',
    'de': 'oder',
    'it': 'o',
  }

  moreOptionsTranslations = {
    'sl': 'Več možnosti',
    'en': 'More options',
    'de': 'Mehr Optionen',
    'it': 'Più opzioni',
  }

  loading = false;

  constructor( private ppTranslatePipe: PpTranslatePipe, public translateService: TranslateService, private modalCtrl: ModalController, private shopDetailService: ShopDetailService, @Inject(LOCALE_ID) protected localeId: string, private providerServiceService: ProviderServiceService )  { 


    this.providerServiceService.services$.subscribe( categories => {

      let servicesById = {};
      
      for( let category of categories ) {
        servicesById['id_' + category.id] = category;
      }

      this.servicesSnapshot = servicesById;
      console.log(this.servicesSnapshot);

    });  

    console.log(localeId);

    this.employeesSubscription = shopDetailService.employees$.subscribe( 
      employees => { 
        this.employees = employees;
        this.employeesMap = this.shopDetailService.generateEmployeesMap( employees );
      }
    );


  }

  ngOnChanges( changes: SimpleChanges ) {

    console.log('B1');

    this.loading = false;

    if ( changes.slots$ ) {
      
      if ( this.slots$ ) {

          if (this.slotsSubscription) {
            this.slotsSubscription.unsubscribe();
          }   

          this.loading = true;

          this.slotsSubscription = this.slots$.subscribe( result  => {

          this.loading = false;
          this.slots = result;

          if (this.initialSlotSubscription) {
            this.initialSlotSubscription.unsubscribe();
          }          

          console.log('B2');

          /*this.initialSlotSubscription = this.initialSlot$.subscribe( result  => {

            console.log('B3');
            if ( result && this.slots  && this.slots.length === 1 && this.slots[0] && result.start === this.slots[0].start && !this.isSlotPicked( this.slots[0] ) ) {
              
              console.log('B4 - Toggle');   
              console.log(result);  
              this.toggleSlot( result );
            }

          });*/

        });
      }

    }

    
  }

  //test and later refactor
  ngOnInit() {

    /*console.log('A1');

    if ( this.slots$ ) {

        console.log('A2');

        if (this.slotsSubscription) {
          this.slotsSubscription.unsubscribe();
        }

        console.log('A3');   

        this.slotsSubscription = this.slots$.subscribe( result  => {

        this.slots = result;
        
        if (this.initialSlotSubscription) {
          this.initialSlotSubscription.unsubscribe();
        }          


        this.initialSlotSubscription = this.initialSlot$.subscribe( result  => {

          if ( result && this.slots  && this.slots.length === 1 && this.slots[0] && result.start === this.slots[0].start  ) {
            
            //&& !this.isSlotPicked( this.slots[0] ) 
            console.log('A4 - Toggle');   
            console.log(result);   
            this.toggleSlot( result );
          }

        });

      });
    }*/
    
  }

  showPaymentProtectionIcon( slot, eventFilter, servicesSnapshot, real ) {

    if ( !slot.events || slot.events.length === 0 ) { //no events

      if ( /*slot.regularOfferAvailable && real.hideALaCarteOption && */( real?.noShowProtection || real?.paymentRequired || real?.minSpendRequired ) ) {

        //@todo replace with dynamic value after api is published
        if ( real.noShowProtection ) {
          return real.hasSlotNoShowProtection( slot.start );
        } else {
          return true;
        }

      }

      return false;

    } 

    let eventId: number;

    //events exist
    if ( eventFilter !== 'all'  ) {
      eventId = parseInt( eventFilter );

    } else if ( slot.events.length === 1 && ( !slot.regularOfferAvailable || ( real.hideCannotDecideOption && real.hideALaCarteOption ) ) ) {

      eventId = slot.events[0];

    } else {
      return false;
    }

    if ( this.servicesSnapshot['id_' + eventId ] ) {
      
      let s = this.servicesSnapshot['id_' + eventId ];

      if ( s.noShowProtection || s.paymentRequired || s.minSpendRequired ) {
        return true;
      }

    }

    return false;

  }

  openPaymentInfoModalFromEventFilter( events, eventFilter ) {

    console.log(events);
    console.log(eventFilter);
    console.log(this.servicesSnapshot);

    for( let e of events ) {

      if ( e == parseInt(eventFilter) ) {

        let s = this.servicesSnapshot['id_' + e ];

        if ( s ) {
          console.log('foo');
          console.log(s);
          this.openPaymentInfoModal(s);
          return;
        }

      }

    }

    this.openPaymentInfoModal(); 

  }

  openOfferInfoModalFromEventFilter( events, eventFilter ) {

    console.log('ff');
    console.log(events);
    console.log(eventFilter);

    for( let e of events ) {

      if ( e == parseInt(eventFilter) || ( events.length === 1 &&  eventFilter === 'all' ) ) {

        let s = this.servicesSnapshot['id_' + e ];

        if ( s ) {
          this.openOfferInfoModal(s);
          return;
        }

      }

    } 

  }

  openPaymentInfoModal( service = null ) {

    console.log(service);
    this.modalCtrl.create({
      component: PaymentInfoModalComponent,
      cssClass: 'my-modal',
      componentProps: { 'service': service, 'real': this.real }
    })
    .then( modalEl => {
      modalEl.present();
      return modalEl.onDidDismiss();
    })
    .then( resultData => {

      /*if ( 'picked' === resultData.role && undefined !== resultData.data  ) {
        //redirect to shop
        this.router.navigate( [ '/restavracija', resultData.data.providerId, resultData.data.slug ] );
      }*/

    });
  }

  openOfferInfoModal(service) {

    console.log('foo');


    this.modalCtrl.create({
      component: OfferInfoModalComponent,
      cssClass: 'my-modal',
      componentProps: { 'service': service }
    })
    .then( modalEl => {
      modalEl.present();
      return modalEl.onDidDismiss();
    })
    .then( resultData => {

      /*if ( 'picked' === resultData.role && undefined !== resultData.data  ) {
        //redirect to shop
        this.router.navigate( [ '/restavracija', resultData.data.providerId, resultData.data.slug ] );
      }*/

    });
  }


  doWeShowSlot( slot ) {

    if ( 'all' === this.eventFilter /*&& slot.regularOfferAvailable*/ ) {
      return true;
    }

    if ( this.eventFilter && slot.events.length > 0 && slot.events.includes( parseInt( this.eventFilter ) ) ) {
      
      return true;

    } 

    return false;

  }

  getMoreOptionsSlotText( events, regularOfferAvailable, lang = 'sl' ) {


    //new default - more options ...
    //return this.moreOptionsTranslations[lang] + ' ...';


    let text = '';
    let exclusive = false;

    if (events.length > 1 || ( events.length === 1 && regularOfferAvailable ) ) {
      return this.moreOptionsTranslations[lang] + ' ...';
    }

    for( let e of events ) {

      let s = this.servicesSnapshot['id_' + e ];

      if ( s ) {

        if (s.exclusiveEvent) {

          exclusive = true;
        }

        if ( text ) {
          text += ' ' + this.orTranslations[lang] + ' ';
        }


        if ( text && ( lang == 'sl' || lang == 'it' ) ) {
          text += this.ppTranslatePipe.transform(s.name, s.nameTranslations, lang).toLowerCase();
        } else {
          text += this.ppTranslatePipe.transform(s.name, s.nameTranslations, lang);
        }
        
      } 

    }

    //text += ' ' + this.orTranslations[lang] + ' ...';

    /*if ( !exclusive ) {
      text += ' ali ...';
    }*/

    return text;

  }

  getSlotText( events, eventFilter, lang = 'sl' ) {


    //console.log(events,eventFilter);
    let text = '';
    let exclusive = false;

    for( let e of events ) {

      let s = this.servicesSnapshot['id_' + e ];

      if ( s ) {

        if (s.exclusiveEvent) {
          exclusive = true;
        }

        if ( eventFilter !== 'all' ) {
          if ( e != eventFilter ) {
            continue;
          }
        }

        if ( text ) {
          text += ' ' + this.orTranslations[lang] + ' ';
        }

        text += this.ppTranslatePipe.transform(s.name, s.nameTranslations, lang);

      } 

    }

    /*if ( !exclusive ) {
      text += ' ali ...';
    }*/

    return text;

  }


  ngOnDestroy() {
    
    if (this.employeesSubscription) {
      this.employeesSubscription.unsubscribe();
    }

    if (this.initialSlotSubscription) {
      this.initialSlotSubscription.unsubscribe();
    }
    
    if (this.slotsSubscription) {
      this.slotsSubscription.unsubscribe();
    }

  }

  isPickSlotStepCompleted() {
    return this.pick.combination;
  }

  getTime( dateString ) {
    return moment( dateString ).format('HH:mm');
  }

  isCombinationPicked( combination ) {
    if ( !this.pick.combination || !combination.attendees || combination.attendees.length === 0 ) {
      return false;
    }
    return ( equal( this.pick.combination.attendees, combination.attendees ) );
  }

  isSlotPicked( slot ) {
    if ( !this.pick.combination ) {
      return false;
    }
    return ( this.pick.combination.start == slot.start );
    //return ( this.selectedTime == slot.start );
  }

  areThereMoreEmployeesPerAttendee( services ) {
    
    if ( !services || services.length < 2 ) {
      return false;
    }

    let employee;

    for( let s of services ) {

      if (!employee) {
        employee = s.employeeHref;
      } else if ( employee !== s.employeeHref ) {
        return true;
      }

    }

    return false;

  }

  //@todo refactor -> same method in summary.component
  getAvatarFileFromEmployeeHref( href ) {

    if ( !href ) {
      return null;
    } 
    
    let employeeId = href.substr( href.lastIndexOf("/") + 1 );
    if ( this.employeesMap[ employeeId ] ) {
      return this.employeesMap[ employeeId ].avatar;
    } 

    return null;
  }


  getNameFromEmployeeHref( href ) {

    if ( !href ) {
      return '';
    } 

    let employeeId = href.substr( href.lastIndexOf("/") + 1 );
    if ( this.employeesMap[ employeeId ] ) {
      return this.employeesMap[ employeeId ].shortName;
    } 

  }

  toggleSlot( slot ) {

    this.eventPreference = null;

    if ( this.eventFilter !== 'all' ) {
      this.eventPreference = this.eventFilter.toString();

    } else {

      /*if ( slot.events.length == 0 ) {
        this.eventPreference = null;
      }*/

      if ( slot.events.length == 1 && !slot.regularOfferAvailable ) {
        this.eventPreference = slot.events[0].toString();
      }

      if ( slot.events.length > 1 ||  ( slot.events.length == 1 && slot.regularOfferAvailable ) ) {
        this.eventPreference = slot.events[0].toString();
      }

    }

    /*//if only one

    let eventPreference: string;

    if ( this.eventFilter !== 'all' ) {
      eventPreference = this.eventFilter;

    } else {

      if ( slot.events.length == 0 ) {
        eventPreference = null;
      }

      if ( slot.events.length == 1 && !slot.regularOfferAvailable ) {
        eventPreference = slot.events[0];
      }

    }*/

    this.onSlotPicked.emit( { slot: slot, eventPreference: this.eventPreference, 'slotClick': true  } );
  }


  toggleCombination( slot, eventPreference ) {
    this.eventPreference = eventPreference;
    this.onSlotPicked.emit( { slot: slot, eventPreference: this.eventPreference, 'slotClick': false  } );
    //this.onSlotPicked.emit( { slot: slot, eventPreference: this.eventPreference  } );
    //this.toggleSlot( slot ) {
    //this.pick.setCombination( c );
  }

  isBrunch( dateString  ) {

    var compareDate = moment(dateString);
    var startDate   = moment("17/12/2022", "DD/MM/YYYY");
    var endDate     = moment("18/12/2022", "DD/MM/YYYY");

    return compareDate.isBetween(startDate, endDate);

  }

  isSilvester( dateString, pick ) {

    var compareDate = moment(dateString);
    var startDate   = moment("31/12/2022", "DD/MM/YYYY");
    var endDate     = moment("01/01/2023", "DD/MM/YYYY");

    return compareDate.isBetween(startDate, endDate);

  }

  getOptions( dateString, pick ) {

    var compareDate = moment(dateString);
    var startDate   = moment("31/12/2022", "DD/MM/YYYY");
    var endDate     = moment("01/01/2023", "DD/MM/YYYY");

    return compareDate.isBetween(startDate, endDate);

  }

}